module.exports = __webpack_public_path__ + "img/bc_payback.d732d5fc.png";